import { useState } from "react";
import PagePadding from "../layouts/PagePadding";
import Input from "../components/form-input/Input";
import InputPassword from "../components/form-input/InputPassword";
import Btn from "../components/btn/create-account/Btn";
import Outer from "../layouts/form/Outer";
import Inner from "../layouts/form/Inner";
import Footer from "../components/onboarding/Footer";
import { handleDisable } from "../utils/btn/handleDisable";
import { useNavigate } from "react-router-dom";
import req from "../axios/interceptedAxiosInstance";
import IsLoading from "../components/loading/IsLoading";
import { errorToast, successToast } from "../notification/notification";

export const CreateNewPassword = ({ setLoading, email }) => {
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const navigate = useNavigate();

  const reqBody = {
    code: code,
    email: email,
    password: password,
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      // eslint-disable-next-line
      password.length >= 8 &&
      password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/) &&
      password.match(/([!,%,&,@,#,$,^,*,?,_,~])/) &&
      password === confirmPassword
    ) {
      setLoading(true);
      try {
        const response = await req.post("auth/new-password", reqBody);
        successToast(response?.data?.message);
        navigate("/sign-in");
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    } else return errorToast("invalid email or password do not match");
  };

  let disable = handleDisable([code, password]);

  return (
    <div className="relative">
      <PagePadding>
        <Outer>
          <Inner>
            <div className="mt-4 flex w-fit gap-14 items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-chevron-left cursor-pointer"
                viewBox="0 0 16 16"
                onClick={() => navigate(-1)}
              >
                <path
                  fillRule="evenodd"
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                />
              </svg>
              <h4 className="font-normal text-2xl">Create New Password</h4>
            </div>

            <form className="mt-8">
              <Input
                type="text"
                placeholder="Code"
                value={code}
                onValueChange={setCode}
                required={true}
                label="Code"
              />

              <div className="relative">
                <InputPassword
                  placeholder="Password"
                  password={password}
                  setPassword={setPassword}
                  label="Password"
                  id="password"
                />
              </div>
              <div className="mt-">
                <InputPassword
                  placeholder="Confirm Password"
                  password={confirmPassword}
                  setPassword={setConfirmPassword}
                  match={password}
                  label="Confirm Password"
                />
              </div>
              <div>
                <Btn
                  innerText="Reset Password"
                  inactive="bg-darkGrey"
                  active="bg-logoRed"
                  onclick={handleSubmit}
                  disable={disable}
                />
              </div>
            </form>
          </Inner>
        </Outer>
      </PagePadding>
      <Footer />
    </div>
  );
};

export default IsLoading(CreateNewPassword, "Creating new password");
